import { render, staticRenderFns } from "./InvitationDifferentAccountModal.vue?vue&type=template&id=6935d14c&scoped=true&"
import script from "./InvitationDifferentAccountModal.vue?vue&type=script&lang=ts&"
export * from "./InvitationDifferentAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationDifferentAccountModal.vue?vue&type=style&index=0&id=6935d14c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6935d14c",
  null
  
)

export default component.exports